import React from "react";
import { useTranslation } from "react-i18next";
import { MdChevronRight } from "react-icons/md";
import { LinkedAccount } from "../../../models/LinkedAccount";
import {
  formatBirthDateDdMmYyyy,
  getLinkedAccountAge,
  getLinkedAccountDisplayName,
  getLinkedAccountInitials,
} from "../../../../utils/linkedAccountDisplay";
import EAButton from "../Buttons/EAButton";
import EAIconButton from "../Buttons/EAIconButton";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";
import "./EALinkedPersonRow.scss";

interface IProps {
  account: LinkedAccount;
  onDetails: () => void;
}

const EALinkedPersonRow: React.FC<IProps> = ({ account, onDetails }) => {
  const { t } = useTranslation();
  const isDesktop = useDesktopSize();
  const displayName = getLinkedAccountDisplayName(account);
  const initials = getLinkedAccountInitials(account);
  const age = getLinkedAccountAge(account);
  const birthFormatted = formatBirthDateDdMmYyyy(account);

  const handleRowClick = () => {
    if (!isDesktop) onDetails();
  };

  return (
    <div
      className={`ea-linked-person-row ${!isDesktop ? "ea-linked-person-row--mobile-clickable" : ""}`}
      onClick={handleRowClick}
      role={!isDesktop ? "button" : undefined}
    >
      <div className="ea-linked-person-row__left">
        <div className="ea-linked-person-row__avatar" aria-hidden>
          {initials}
        </div>
        <div className="ea-linked-person-row__content">
          <h5 className="ea-linked-person-row__name">{displayName}</h5>
          <span className="ea-linked-person-row__meta body-text-small text-color-dark-gray">
            {age !== null && (
              <>
                {age} {t("my_account_age_unit")}
              </>
            )}
            {" · "}
            urodz. {birthFormatted}
          </span>
        </div>
      </div>
      <div className="ea-linked-person-row__right" onClick={(e) => e.stopPropagation()}>
        {isDesktop ? (
          <EAButton title={t("linked_account_details_action")} variant="filled" color="primary" onClick={onDetails} />
        ) : (
          <EAIconButton
            title={t("linked_account_details_action")}
            icon={<MdChevronRight />}
            variant="icon"
            color="primary"
            onClick={onDetails}
          />
        )}
      </div>
    </div>
  );
};

export default EALinkedPersonRow;
